import React from 'react';
import Page from 'components/page/Page';
import { RoleUpdateRequest } from 'api/adgang/models';
import { Button, LoadingSpinner, useFetch } from 'common.ui';

import RoleForm from 'components/roles/RoleForm';
import { rolesClient } from 'api/AdgangClients';
import { useHistory, useParams } from 'react-router-dom';
import { AdgangAccessControl } from 'api/adgang';
import { useAccessControlList } from 'hooks/access/useAccessControlList';
import RoutePaths from 'RoutePaths';

interface IParams {
  id: string;
}

function UpdateRole() {
  const { id } = useParams<IParams>();
  const history = useHistory();
  const [, hasAccess] = useAccessControlList();

  const [role] = useFetch(async () => rolesClient.getRolebyId({ id: +id }), undefined, false, [id]);

  async function onSave(model: RoleUpdateRequest) {
    await rolesClient.apiRolesIdPut({
      id: +id,
      roleUpdateRequest: model
    });
  }

  return (
    <Page header='Detaljer om rolle' title={['Rolle', role?.name || '']}>
      {role ? (
        <>
          {hasAccess(AdgangAccessControl.ManageEntraSecurityGroups) && (
            <Button
              styleType='light'
              text='Entra-sikkerhetsgruppe'
              onClick={() => history.push(RoutePaths.roleSecurityGroup.replace(':id', id))}
            />
          )}
          <RoleForm<RoleUpdateRequest>
            onSave={onSave}
            initialValue={role}
            onSaveLabel='Lagre'
            isUpdate
            resourceBasedAcl={role.accessControls ?? []}
            isUnlocksExternalApproverRightsRole={role.unlocksExternalApproverRights}
          />
        </>
      ) : (
        <LoadingSpinner />
      )}
    </Page>
  );
}

export default UpdateRole;
